// Debug utilities for development
import { ShopService } from '../services/shopService';
import { userPreferences } from './userPreferences';

// Add cache debug info to window object for easy debugging
declare global {
    interface Window {
        loppehubDebug: {
            shopCache: {
                stats: () => any;
                clear: () => void;
                refresh: () => Promise<any>;
            };
            preferences: {
                get: () => any;
                set: (updates: any) => void;
                reset: () => void;
                export: () => string;
                import: (json: string) => boolean;
            };
        };
    }
}

export const initializeDebugTools = () => {
    console.log('🔧 [Debug] Initializing debug tools...', {
        isDev: import.meta.env.DEV,
        mode: import.meta.env.MODE
    });

    // Always initialize debug tools for easier debugging
    window.loppehubDebug = {
        shopCache: {
            stats: () => ShopService.getCacheStats(),
            clear: () => ShopService.clearCache(),
            refresh: () => ShopService.refreshShops(),
        },

        preferences: {
            get: () => userPreferences.all,
            set: (updates) => userPreferences.updatePreferences(updates),
            reset: () => userPreferences.reset(),
            export: () => userPreferences.export(),
            import: (json) => userPreferences.import(json),
        },
    };

    console.log('✅ [Debug] Debug tools initialized at window.loppehubDebug');
    console.log('📊 [Debug] Initial cache stats:', ShopService.getCacheStats());
};